export default __webpack_public_path__ + "static/media/jar.d6c73977.png";